import { ButtonType, ButtonWidget, CompactInlineAlertWidget, DropdownButtonType, InlineAlertType, List, ListItem, SingleSelectDropdown, StackingRootContext, TextFieldWidget } from '@tableau/widgets';
import React from 'react';
import { match } from 'react-router-dom';
import _ from 'underscore';

import { Location } from '~commonInfra/utils/Location';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { RouterError } from '~src/bootstrap/routerHelpers/RouterError';
import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { UserSettingsStyle } from '~src/userSettings/styles/UserSettingsStyle';

import { getSessionManagementServiceInstance } from '../../../sessionManagement/SessionManagementService';
import { IScimContext } from '../serverApi/types/IScimContext';
import { ISiteScimConfiguration } from '../serverApi/types/ISiteScimConfiguration';
import { IScimConfiguration, ScimConfigurationsService } from '../services/ScimConfigurationsService';
import {
  AuthenticationProviderType,
  ISiteAuthenticationSettings,
  SiteAuthenticationSettingsService
} from '../services/SiteAuthenticationSettingsService';
import { samlProviderAlertText, samlProviderGroupSettings } from '../styles/SAMLAuthenticationProviderStyle';
import { authDropdownStyle, backButtonSectionStyle, newConfigurationContainer, newConfigurationHeaderText, textFieldContainer } from '../styles/SiteAuthenticationSettingsStyles';
import { AuthenticationBackButton } from './AuthenticationBackButton';
import { DiscardChangesDialog } from './multipleIDPComponents/DiscardChangesDialog';


export interface ScimConfigurationSpaceComponentProps {
  isNewConfigPage?: boolean;
  urls?: SpacesSiteUrls;
}

export interface ScimConfigurationSpaceMatchProps {
  config?: string;
}

export type ScimConfigurationSpaceRoutedProps = match<ScimConfigurationSpaceMatchProps>;

export type ScimConfigurationSpaceProps = ScimConfigurationSpaceComponentProps & ScimConfigurationSpaceRoutedProps;

export interface ScimConfigurationSpaceState {
  hasError: boolean;
  scimConfigurationName: string;
  baseUrl: string;
  scimProviderDropDownListItems: ListItem[];
  selectedSCIMProvider: ListItem;
  scimProviderAuthList: ConfigurationAuth[];
  selectedAuthType: string;
  secret: string;
  isGenerateSecretButtonVisible: boolean;
  isConfigSaved: boolean;
  //edit page states 
  isScimConfigNameUpdated: boolean;
  isSCIMProviderUpdated: boolean;
  isSecretUpdated: boolean;
  scimConfigurationSavedToDatabase: IScimConfiguration;
  configurationId: string;
  scimContext: IScimContext | null;
}

interface ConfigurationAuth{
  value: string;
  type: string;
}
const SCIM_CONFIGURATION_NAME_REGEXP: RegExp = new RegExp('^([a-zA-Z0-9 _-]+)$');
const SCIM_CONFIG_NAME_LENGTH = 35;




export class ScimConfigurationSpace extends React.Component<ScimConfigurationSpaceProps, ScimConfigurationSpaceState> {

private SCIM_CLIENT_API_TOKEN = 'SCIM_CLIENT_API_TOKEN';
private SCIM_CLIENT_API_TOKEN_PREFIX = this.SCIM_CLIENT_API_TOKEN + ':';

  constructor(props: ScimConfigurationSpaceProps) {
    super(props);
    this.state = {
      hasError: false,
      scimConfigurationName: '',
      baseUrl: this.getBaseUrl(true),
      scimProviderDropDownListItems: [],
      selectedSCIMProvider: undefined,
      scimProviderAuthList: [],
      selectedAuthType: '',
      secret: null,
      isGenerateSecretButtonVisible: false,
      isConfigSaved: false,
      //edit page states
      isScimConfigNameUpdated: false,
      isSCIMProviderUpdated: false,
      isSecretUpdated: false,
      scimConfigurationSavedToDatabase: undefined,
      configurationId:'',
      scimContext: null,
    };
  }

  componentDidMount(): void {
    this.setUpInitialState();
  }

  private initScimState(siteAuthSettings: ISiteAuthenticationSettings): void {

    const enabledSCIMProviders = siteAuthSettings?.allProviders?.filter((provider) => provider.isEnabled && (provider.type === AuthenticationProviderType.saml || provider.type === AuthenticationProviderType.oidc));
    if (enabledSCIMProviders?.length === 0 && this.props.isNewConfigPage) {
      this.setState({ hasError: true });
      return;
    }
    const providerItems = enabledSCIMProviders.map((provider) => {
      return {
        content:
          <div>
            {provider.idpConfigurationName}
          </div>,
        testId: 'configuration-scim-button',
        value: provider.idpConfigurationId,
        type: provider.type
      };
    });
      this.setState({ scimProviderDropDownListItems: providerItems, scimProviderAuthList: providerItems }, () => {
        if(!this.props.isNewConfigPage)
        {
           this.setUpEditConfigurationState();
        }
      });
  }

  private setUpEditConfigurationState(refresh: boolean = false){
    const configurationId = this.props.params.config;
      if(configurationId)
      {
        ScimConfigurationsService.getAllScimConfigurations(refresh).then((scimConfigurations: IScimConfiguration[])=>{
          const config = _.find(scimConfigurations, (scimConfig: IScimConfiguration) => (scimConfig.id === configurationId));
          if (config) {
            const scimProviderSavedToDatabase: ListItem | null =
              this.state.scimProviderDropDownListItems.find(
                (provider) => provider.value === config.idpConfigurationId
              ) || null;
            const scimAuthSavedToDatabase: ConfigurationAuth | null = this.state.scimProviderAuthList.find(
              (provider) => provider.value === config.idpConfigurationId
            ) || null;
            this.setState({
              scimConfigurationName: config.name,
              selectedSCIMProvider: scimProviderSavedToDatabase,
              selectedAuthType: scimAuthSavedToDatabase.type,
              scimConfigurationSavedToDatabase: config,
              configurationId: configurationId,
            });
          }
          else {
            this.setState({ hasError: true });
          }
        });
      }
     else {
      this.setState({ hasError: true });
     }
  }

  private setUpInitialState(refresh: boolean = false) {
    SiteAuthenticationSettingsService.getSiteAuthenticationSettings(refresh)
      .then((siteAuthSettings: ISiteAuthenticationSettings) => {
        this.initScimState(siteAuthSettings);
      });

    if (FeatureFlags.scimDynamicBaseUrlEnabled) {
      SiteAuthenticationSettingsService.getScimContext()
        .then((scimContext: IScimContext) => {
          this.setState({ scimContext, baseUrl: this.getBaseUrl(true, scimContext) });
        })
        .catch(() => {
          ToasterService.instance.pop({ type: ToastType.Error, text: Messages.unexpectedError() });
        });
    }
  }

  // refresh configuration table when a config is created/edited
  private refreshScimConfigurationsTable(refresh: boolean) {
    ScimConfigurationsService.getAllScimConfigurations(refresh);
  }

  private getServerSessionSiteLuid = () => {
    return getSessionManagementServiceInstance().sessionSiteLuid();
  };

  private isSaveDisabled(): boolean {
    //disabling save if either of config name and auth type is missing
    //disabling save if scim config name is not a valid one
    const { scimConfigurationName, selectedSCIMProvider } = this.state;

    return !scimConfigurationName
      || scimConfigurationName.trim().length === 0
      || !this.isValidScimConfigurationName(scimConfigurationName)
      || this.isScimConfigurationNameExceedingMaxLength(scimConfigurationName)
      || !selectedSCIMProvider;
  }

  private isValidScimConfigurationName(scimConfigurationName: string): boolean {
    return scimConfigurationName === '' || SCIM_CONFIGURATION_NAME_REGEXP.test(scimConfigurationName);
  }

  private isScimConfigurationNameExceedingMaxLength(scimConfigurationName: string): boolean {
    return scimConfigurationName !== '' && scimConfigurationName.length > SCIM_CONFIG_NAME_LENGTH;
  }

  //update the state of scim configuration name field
  private setScimConfigurationName(name: string) {
    this.setState({ scimConfigurationName: name.trim() });
    if (!this.props.isNewConfigPage) {
      const isNameChanged = name.trim() !== this.state.scimConfigurationSavedToDatabase.name;
      this.setState({ isScimConfigNameUpdated: isNameChanged });
    }
  }

  //update the scim Provider dropdown value
  private selectConfigurationforScim(id: string) {
    this.setState(
      {
        selectedSCIMProvider: this.state.scimProviderDropDownListItems.find(
          (item: ListItem) => item.value === id
        ),
        selectedAuthType : this.state.scimProviderAuthList.find(
          (item: ConfigurationAuth) => item.value === id
        )?.type
      },
    );

    if (!this.props.isNewConfigPage) {
      const isSCIMProviderChanged = id !== this.state.scimConfigurationSavedToDatabase.idpConfigurationId;
      this.setState({
        isSCIMProviderUpdated: isSCIMProviderChanged
      });
    }
  }

  // set the value of secret
  private setSecret(tokenSecret: string): void {
    this.setState({ secret: tokenSecret });
  }

  // method called on clicking save button for creating new scim config
  private sendSaveNewScimConfigRequest(): void {
    const scimConfig: IScimConfiguration = {
      name: this.state.scimConfigurationName,
      idpConfigurationId: this.state.selectedSCIMProvider.value,
      type: this.state.selectedAuthType
    };
    ScimConfigurationsService.createNewScimConfiguration(scimConfig)
      .then((result: IScimConfiguration) => {
        ToasterService.instance.pop({
          type: ToastType.Success,
          text: Messages.newScimConfigurationSuccess({ SCIM_CONFIG_NAME: scimConfig.name })
        });
        this.setState({
          isGenerateSecretButtonVisible: true,
          scimConfigurationSavedToDatabase: result,
          isConfigSaved: true
        });
        this.refreshScimConfigurationsTable(true);
        this.setSiteScimConfiguration([this.state.selectedSCIMProvider.value]);
      })
      .catch(() => {
        ToasterService.instance.pop({
          type: ToastType.Error,
          text: Messages.newScimConfigurationError()
        });
      });
  }

  private setSiteScimConfiguration(idpConfigurationIds: string[]): Promise<any> {
    return this.notifyOnFail(this.createOrUpdateScimConfiguration({ idpConfigurationIds }));
  }

   private createOrUpdateScimConfiguration = (config: ISiteScimConfiguration) => {
          return SiteAuthenticationSettingsService.createOrUpdateScimConfiguration(config);
  };

  //method call on clicking save changes button while editing config
  private sendUpdateScimRequest(): void {
    const updateConfigRequestBody: Partial<IScimConfiguration> = {};
    updateConfigRequestBody.id=this.state.configurationId;
    if (this.state.isScimConfigNameUpdated) {
      updateConfigRequestBody.name = this.state.scimConfigurationName;
    }
    if (this.state.isSCIMProviderUpdated) {
      updateConfigRequestBody.idpConfigurationId = this.state.selectedSCIMProvider.value;
      updateConfigRequestBody.type = this.state.selectedAuthType;
    }

    ScimConfigurationsService.updateScimConfiguration(updateConfigRequestBody)
      .then(() => {
        ToasterService.instance.pop({
          type: ToastType.Success,
          text: Messages.updateScimConfigurationSuccess({ SCIM_CONFIG_NAME: this.state.scimConfigurationName })
        });
        this.refreshScimConfigurationsTable(true);
        // assign states to toggle UI
        if(this.state.isSCIMProviderUpdated) {
          if(this.state.scimConfigurationSavedToDatabase.isApiTokenActive){
            this.setState({
              scimConfigurationSavedToDatabase: {
                ...this.state.scimConfigurationSavedToDatabase,
                isApiTokenActive: false,
              },
            });
          }
          this.setState({
            scimConfigurationSavedToDatabase: {
              ...this.state.scimConfigurationSavedToDatabase,
              idpConfigurationId: updateConfigRequestBody.idpConfigurationId,
            },
          });
          this.setSiteScimConfiguration([this.state.selectedSCIMProvider.value]);
      }
      //secret is not deleted if ONLY scim config name is updated
        if(this.state.isScimConfigNameUpdated){
          this.setState({
            scimConfigurationSavedToDatabase: {
              ...this.state.scimConfigurationSavedToDatabase,
              name: updateConfigRequestBody.name,
            },
          });
        }
        this.setState({ isScimConfigNameUpdated:false });
        this.setState({ isSCIMProviderUpdated:false });
      })
      .catch(() => {
        ToasterService.instance.pop({
          type: ToastType.Error,
          text: Messages.updateScimConfigurationError()
        });
      });
  }

  private saveChangesOnClick = () => {
    const { isNewConfigPage } = this.props;

    if (isNewConfigPage) {
      this.sendSaveNewScimConfigRequest();
      return;
    }

    else {
      this.sendUpdateScimRequest();
      return;
    }
  };

  // display dialog box on clicking cancel button
  private cancelOnClick = () => {
    DiscardChangesDialog(Messages.siteSCIMConfiguration());
  };

  private selectAll(event: any): void {
    event.target.select();
  }

  // direct to auth page on clicking close button
  private handleCloseButtonClick = () => {
    const urls = siteUrlsSelector(getAppStore().getState());
    const authUrl = urls.settingsAuthenticationUrl();
    Location.instance.setUrl(authUrl);
  };

  // checks if there is any change in the form
  private unsavedChangesArePresent(): boolean {
    if (this.props.isNewConfigPage) {
      return Boolean(this.state.scimConfigurationName || this.state.selectedSCIMProvider);
    }
    return Boolean(this.state.isSCIMProviderUpdated || this.state.isScimConfigNameUpdated);
  }

  private getBaseUrl(scimEnabled: boolean, scimContext?: IScimContext): string {
    if (!scimEnabled) {
      return 'https://';
    }
    if (FeatureFlags.scimDynamicBaseUrlEnabled) {
      const context = scimContext || this.state?.scimContext;
      if (!context) {
        return 'https://';
      }
      return context.scimBaseUrl + '/sites/' + this.getServerSessionSiteLuid() + '/scim/v2';
    }
    const podName = window.location.hostname === 'localhost' ?
      'local-pod-fake' : window.location.hostname.split('.')[0];
    return 'https://scim.online.tableau.com/pods/' + podName +
      '/sites/' + this.getServerSessionSiteLuid() + '/scim/v2';
  }


  // function called on clicking generate new secret button -- first delete the existing token and then create new one
  generateNewToken<TResult>(): void {

    openReactConfirmationDialog<void, TResult>({
      title: Messages.scimConfigurationGenerateNewSecret(),
      message: (this.state.scimConfigurationSavedToDatabase.isApiTokenActive) ? Messages.activeSecretGenerateSecretConfirmBody() : Messages.inactiveSecretGenerateSecretConfirmBody(),
      paramsForAction: undefined,
      action: () => {
        if (this.state.scimConfigurationSavedToDatabase.isApiTokenActive) {
          return this.deleteScimConfigToken().then(() => this.createScimConfigToken());
        } else {
          return this.createScimConfigToken();
        }
      },
      actionName: Messages.scimConfigurationGenerateNewSecret(),
      isActionDelete: false,
      dialogWidth: TabDialogWidth.width375px
    });
  }


  //creates a token for scim configuration
  createScimConfigToken(): Promise<any> {
    return this.notifyOnFail(
      ScimConfigurationsService.createApiTokenForScimConfiguration({
      scimConfigId: this.state.scimConfigurationSavedToDatabase.id
    }).then((secret: string) => {
      this.setSecret(secret);
      this.setState({
        scimConfigurationSavedToDatabase: {
          ...this.state.scimConfigurationSavedToDatabase,
          isApiTokenActive: true,
        },
        isSecretUpdated: true,
      });
      this.refreshScimConfigurationsTable(true);
    })
    );
  }

 // error toast if secret generation fails
  private notifyOnFail<TResult>(result: Promise<TResult>): Promise<TResult> {
    result.catch(() => {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.unexpectedError() });
    });
    return result;
  }

  // deletes token for scim configuration
  deleteScimConfigToken(): Promise<any> {
    return this.notifyOnFail(
      ScimConfigurationsService.deleteApiTokenForScimConfiguration(this.state.scimConfigurationSavedToDatabase.id)
        .then(() => {
          this.setState({
            scimConfigurationSavedToDatabase: {
              ...this.state.scimConfigurationSavedToDatabase,
              isApiTokenActive: false,
            },
          });
          this.setSecret(null);
          this.refreshScimConfigurationsTable(true);
        })
    );
  }

  private renderScimConfiguration(): JSX.Element {
    return <>
      <span style={backButtonSectionStyle}>
        <AuthenticationBackButton displayDiscardChangesDialog={this.unsavedChangesArePresent()} discardChangesDialogTitle={Messages.siteSCIMConfiguration()} />
      </span>
      <div style={newConfigurationHeaderText}>
        {this.props.isNewConfigPage
          ? Messages.siteNewScimConfigurationHeading()
          : Messages.siteEditScimConfigurationHeading()}
      </div>
      <div className="tb-settings-control" style={{marginBottom:'9px'}}>
        {Messages.scimConfigurationDesc()}
        &nbsp;
      </div>
      <TextFieldWidget
        onChange={(evt) => this.setScimConfigurationName(evt.target.value)}
        kind='line'
        label={Messages.scimConfigurationName()}
        testId='scim-configuration-name-field-text'
        style={textFieldContainer}
        value={this.state.scimConfigurationName}
        readOnly={this.state.isConfigSaved}
      />
      {!this.isValidScimConfigurationName(this.state.scimConfigurationName) ?
        <div style={samlProviderGroupSettings}>
          <CompactInlineAlertWidget type={InlineAlertType.Info} testId="scim-name-invalid" style={samlProviderAlertText}>
            {<div>{Messages.scimConfigInvalidChars()}</div>}
          </CompactInlineAlertWidget>
        </div>
        : null}
      {this.isScimConfigurationNameExceedingMaxLength(this.state.scimConfigurationName) ?
        <div style={samlProviderGroupSettings}>
          <CompactInlineAlertWidget type={InlineAlertType.Info} testId="scim-name-exceed-max-length" style={samlProviderAlertText}>
            {<div>{Messages.scimConfigMaxLengthExceeded()}</div>}
          </CompactInlineAlertWidget>
        </div>
        : null}
      <div>
        <TextFieldWidget
          value={this.state.baseUrl}
          kind="line"
          label={Messages.scimBaseUrl()}
          testId="scim-config-base-url-text"
          readOnly
          style={textFieldContainer}
          onClick={this.selectAll}
        />
      </div>
      <div>
        <StackingRootContext.Provider value={null}>
            <SingleSelectDropdown
              list={<List items={this.state.scimProviderDropDownListItems} style={{ maxWidth: 390 }} />}
              onChange={this.selectConfigurationforScim.bind(this)}
              disabled={this.state.isConfigSaved}
              value={(this.state.selectedSCIMProvider?.value)}
              label={Messages.authentication()}
              type={DropdownButtonType.Outline}
              style={{ ...authDropdownStyle, maxWidth: '390px' }}
              testId='authentication-for-scim-config-dropdown'>
              {this.state.selectedSCIMProvider ? (this.state.selectedSCIMProvider.content) : Messages.selectAuthentication()}
            </SingleSelectDropdown>
        </StackingRootContext.Provider>
      </div>
      {this.props.isNewConfigPage ?  //new config page
        <div>
          <div className="tb-settings-control">
            {!this.state.isGenerateSecretButtonVisible ? (
              <>
                {this.renderSaveAndCancelButtons()}
              </>
            ) : (
              <>
                {this.renderScimSecretGenerateButton()}
              </>
            )}
          </div>
          <div style={{ paddingTop: '15px' }}>
            {this.state.secret !== null && (
              <><TextFieldWidget
                value={this.state.secret}
                kind="line"
                label={Messages.personalAccessTokenSecret()}
                testId="scim-secret"
                readOnly
                style={textFieldContainer}
                onClick={this.selectAll} />
                <CompactInlineAlertWidget type={InlineAlertType.Info} testId="" style={{ ...samlProviderAlertText, width: '390px' }}>
                  {<div>{Messages.scimConfigurationSecretInfo()}</div>}
                </CompactInlineAlertWidget></>
            )}
            {this.state.isGenerateSecretButtonVisible &&
              <div>
                <ButtonWidget
                  buttonType={ButtonType.Outline}
                  testId={'scim-config-close-button'}
                  style={{ marginTop: '10px' }}
                  onClick={this.handleCloseButtonClick.bind(this)}>
                  {Messages.close()}
                </ButtonWidget>
              </div>
            }
          </div>
        </div> : //edit page
        <div>
          {!(this.state.isScimConfigNameUpdated || this.state.isSCIMProviderUpdated) ? (
            <div>
              <div>{this.renderScimSecretGenerateButton()}</div>
              <div style={{ paddingTop: '15px' }}>
                {this.state.scimConfigurationSavedToDatabase && this.state.scimConfigurationSavedToDatabase.isApiTokenActive && (
                  <>
                    <TextFieldWidget
                      value={this.state.isSecretUpdated && this.state.secret
                        ? this.state.secret : '*'.repeat(69)}
                      kind="line"
                      label={Messages.personalAccessTokenSecret()}
                      testId="scim-secret"
                      readOnly
                      style={textFieldContainer}
                      onClick={this.selectAll}
                    />
                    {this.state.isSecretUpdated && (
                      <CompactInlineAlertWidget
                        type={InlineAlertType.Info}
                        testId=""
                        style={{ ...samlProviderAlertText, width: '390px' }}
                      >
                        {Messages.scimConfigurationSecretInfo()}
                      </CompactInlineAlertWidget>
                    )}
                  </>
                )}
                <div>
                  <ButtonWidget
                    buttonType={ButtonType.Outline}
                    testId={'scim-config-close-button'}
                    style={{ marginTop: '10px' }}
                    onClick={this.handleCloseButtonClick.bind(this)}>
                    {Messages.close()}
                  </ButtonWidget>
                </div>
              </div>
            </div>
          ) : (
            <>
                {this.renderSaveAndCancelButtons()}
            </>
          )
          }
        </div>
      }
    </>;
  }

  private renderSaveAndCancelButtons(): JSX.Element {
    return <>
      <div className="tb-settings-control" style={{ paddingTop: '6px' }}>
        <span className={UserSettingsStyle.cancelButton}>
          <ButtonWidget
            type="reset"
            buttonType={ButtonType.Outline}
            onClick={this.cancelOnClick.bind(this)}
            disabled={!this.unsavedChangesArePresent()}
            testId={'scim-config-cancel-changes-button'}
          >
            {Messages.cancel()}
          </ButtonWidget>
        </span>
        <span>
          <ButtonWidget
            type="submit"
            buttonType={ButtonType.Primary}
            onClick={this.saveChangesOnClick.bind(this)}
            disabled={this.isSaveDisabled()}
            testId={'scim-config-save-changes-button'}
          >
            {this.props.isNewConfigPage ? Messages.save() : Messages.saveChanges()}
          </ButtonWidget>
        </span>

      </div>
    </>;
  }

  private renderScimSecretGenerateButton(): JSX.Element {
    return <>
      <div className="tb-settings-control" style={{ marginTop: '9px' }}>
        {Messages.scimToken()}
      </div>
      <div>
        <ButtonWidget
          buttonType={ButtonType.Outline}
          onClick={this.generateNewToken.bind(this)}
          testId={'scim-create-apitoken'}
        >
          {Messages.scimConfigurationGenerateNewSecret()}
        </ButtonWidget>
      </div>
    </>;
  }

  public render(): JSX.Element {
    if (this.state.hasError) {
      if(this.props.isNewConfigPage){
        return <RouterError errorType={'new-scim-config'} urls={this.props.urls} />;
      }
      return <RouterError errorType={'default'} urls={this.props.urls} />;
    }
    return (
      <div className="tb-scroll">
        <div style={newConfigurationContainer}>
          {this.renderScimConfiguration()}
        </div>
      </div>
    );
  }
}
